import { Link } from 'gatsby'

import './styles.scss'

interface CallToActionProps {
  text: string
  link: string
  fontColor?: string
  backgroundColor?: string
  hover?: string
}

export function CallToAction({
  text,
  link,
  fontColor = '#001018',
  backgroundColor = '#ffea28',
  hover = '',
}: CallToActionProps) {
  return (
    <Link
      className={hover ? `cta hover:!bg-[${hover}]` : 'cta'}
      to={link}
      style={{
        color: fontColor,
        backgroundColor,
      }}
    >
      {text}
    </Link>
  )
}
